import { useInfiniteQuery } from '@tanstack/react-query';
import { DemoFilterRequest } from '../../aida/containers/Demos/utils';
import { ILeadSearchView } from '../../aida/viewModels/leads/interfaces';
import { ImpersonationBroker, IPagedCollection } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/demos/filter';

export function useLeadDemosQuery({
	pageSize = 50,
	filterBody,
	enabled,
	meta,
}: {
	filterBody: DemoFilterRequest;
	pageSize?: number;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		queryKey: [BASE_QUERY_KEY, filterBody],
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<ILeadSearchView>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: 'lead/demos/filter',
					queryParams: {
						pageSize,
						pageToken: pageParam,
					},
				}),
				'POST',
				filterBody
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
		enabled,
		meta,
		staleTime: 1000 * 60, // 1 minute
		refetchOnWindowFocus: false,
		retry: 1,
	});
}
